"use strict";
var unitas = unitas || {};
const darkoverlay = document.getElementById("js-dark-overlay");
unitas.darkoverlay =
  unitas.darkoverlay ||
  (function () {
    function init() {}
    function show() {
      darkoverlay.classList.add("dark-overlay--visible");
    }
    function hide() {
      darkoverlay.classList.remove("dark-overlay--visible");
    }
    return {
      init: init,
      show: show,
      hide: hide,
    };
  })();
